<template>
  <div class="v2-upcoming-events">
    <div v-if="loading" class="v2-upcoming-events__loading">
      <v-icon size="32" color="grey lighten-1">mdi-progress-clock</v-icon>
      <p class="v2-body v2-body--sm v2-body--muted">Cargando eventos…</p>
    </div>

    <EmptyState
      v-else-if="!items || items.length === 0"
      title="Sin eventos próximos"
      description="Cuando tu cámara publique eventos disponibles, aparecerán aquí."
      icon="mdi-calendar-blank-outline"
    />

    <ul v-else class="v2-upcoming-events__list">
      <li
        v-for="item in items"
        :key="getItemId(item)"
        class="v2-upcoming-events__item"
      >
        <UpcomingEventHorizontal :event="unwrapEvent(item)" />
      </li>
    </ul>

    <div v-if="locked" class="v2-locked-overlay">
      <span class="v2-locked-overlay__icon">
        <v-icon size="40" color="white">mdi-lock</v-icon>
      </span>
      <h3 class="v2-locked-overlay__title">Contenido bloqueado</h3>
      <p class="v2-locked-overlay__description">
        Los eventos y beneficios están disponibles solo para miembros activos. Renueva tu membresía para continuar.
      </p>
      <div class="v2-locked-overlay__actions">
        <BaseButton variant="amber" to="/member/renew" icon="mdi-refresh">
          Renovar Membresía
        </BaseButton>
        <BaseButton variant="secondary" icon="mdi-help-circle-outline">
          Hablar con Soporte
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/memberDashboardV2/ui/BaseButton.vue";
import EmptyState from "@/components/memberDashboardV2/ui/EmptyState.vue";
import UpcomingEventHorizontal from "./UpcomingEventHorizontal.vue";
import { getEventId } from "@/views/memberDashboardV2/events/eventsHelpers";

export default {
  name: "UpcomingEvents",
  components: { BaseButton, EmptyState, UpcomingEventHorizontal },
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    locked: { type: Boolean, default: false },
  },
  methods: {
    getItemId: getEventId,
    unwrapEvent(item) {
      if (item && item.event) return item.event;
      return item;
    },
  },
};
</script>

<style scoped>
.v2-upcoming-events {
  position: relative;
}

.v2-upcoming-events__loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-6);
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
}

.v2-upcoming-events__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-3);
}

@media (min-width: 1024px) {
  .v2-upcoming-events__list {
    grid-template-columns: 1fr;
    gap: var(--space-4);
  }
}

.v2-upcoming-events__item {
  display: flex;
  min-width: 0;
}

.v2-upcoming-events__item > * {
  flex: 1 1 auto;
  width: 100%;
}
</style>